import firebase from 'firebase';

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyAxQxC8n-7Nw39kSi_K9jyEbJGzNlr8gKc",
  authDomain: "curby-67811.firebaseapp.com",
  databaseURL: "https://curby-67811.firebaseio.com",
  projectId: "curby-67811",
  storageBucket: "curby-67811.appspot.com",
  messagingSenderId: "545677092075",
  appId: "1:545677092075:web:62523799e47ea5422f0aae",
  measurementId: "G-B519CCRRG9"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

export default firebase;
